export const osMapping: Record<string, string> = {
  "darwin-arm64": "macOS (ARM64)",
  "darwin-x86_64": "macOS (x86_64)",
  "linux-arm64": "Linux (ARM64)",
  "linux-x86_64": "Linux (x86_64)",
  "windows-arm64": "Windows (ARM64)",
  "windows-x86_64": "Windows (x86_64)",
};
